/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  OperatoreCreateDTO,
  OperatoreDTO,
  OperatoreUpdateDTO,
  ProblemDetails,
} from '../models/index';
import {
    OperatoreCreateDTOFromJSON,
    OperatoreCreateDTOToJSON,
    OperatoreDTOFromJSON,
    OperatoreDTOToJSON,
    OperatoreUpdateDTOFromJSON,
    OperatoreUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteOperatoreRequest {
    operatoreId: string;
    tenantId: string;
}

export interface GetOperatoreByIdRequest {
    operatoreId: string;
    tenantId: string;
}

export interface GetOperatoriRequest {
    tenantId: string;
}

export interface InsertOperatoreRequest {
    tenantId: string;
    operatoreCreateDTO?: OperatoreCreateDTO;
}

export interface UpdateOperatoreRequest {
    operatoreId: string;
    tenantId: string;
    operatoreUpdateDTO?: OperatoreUpdateDTO;
}

/**
 * 
 */
export class OperatoriApi extends runtime.BaseAPI {

    /**
     */
    async deleteOperatoreRaw(requestParameters: DeleteOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['operatoreId'] == null) {
            throw new runtime.RequiredError(
                'operatoreId',
                'Required parameter "operatoreId" was null or undefined when calling deleteOperatore().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteOperatore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Operatori/{operatoreId}`.replace(`{${"operatoreId"}}`, encodeURIComponent(String(requestParameters['operatoreId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteOperatore(requestParameters: DeleteOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteOperatoreRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getOperatoreByIdRaw(requestParameters: GetOperatoreByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperatoreDTO>> {
        if (requestParameters['operatoreId'] == null) {
            throw new runtime.RequiredError(
                'operatoreId',
                'Required parameter "operatoreId" was null or undefined when calling getOperatoreById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getOperatoreById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Operatori/{operatoreId}`.replace(`{${"operatoreId"}}`, encodeURIComponent(String(requestParameters['operatoreId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperatoreDTOFromJSON(jsonValue));
    }

    /**
     */
    async getOperatoreById(requestParameters: GetOperatoreByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperatoreDTO> {
        const response = await this.getOperatoreByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getOperatoriRaw(requestParameters: GetOperatoriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OperatoreDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getOperatori().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Operatori`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OperatoreDTOFromJSON));
    }

    /**
     */
    async getOperatori(requestParameters: GetOperatoriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OperatoreDTO>> {
        const response = await this.getOperatoriRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertOperatoreRaw(requestParameters: InsertOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OperatoreDTO>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertOperatore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Operatori`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OperatoreCreateDTOToJSON(requestParameters['operatoreCreateDTO']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OperatoreDTOFromJSON(jsonValue));
    }

    /**
     */
    async insertOperatore(requestParameters: InsertOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OperatoreDTO> {
        const response = await this.insertOperatoreRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateOperatoreRaw(requestParameters: UpdateOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['operatoreId'] == null) {
            throw new runtime.RequiredError(
                'operatoreId',
                'Required parameter "operatoreId" was null or undefined when calling updateOperatore().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateOperatore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Operatori/{operatoreId}`.replace(`{${"operatoreId"}}`, encodeURIComponent(String(requestParameters['operatoreId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OperatoreUpdateDTOToJSON(requestParameters['operatoreUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateOperatore(requestParameters: UpdateOperatoreRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateOperatoreRaw(requestParameters, initOverrides);
    }

}
